import React, { Component } from 'react';

const defaultSlideStyle = {
  width: '100%',
  float: 'left',
  marginRight: '-100%',
  position: 'relative',
  opacity: 0,
  display: 'block',
  zIndex: 1,

};

const activeSlideStyle = {
  ...defaultSlideStyle,
  opacity: 1,
  zIndex: 2,
};

class HeaderSection extends Component {
  constructor() {
    super();
    this.state = {
      bgImages: ['1', '2', '3'],
      activeImgIndex: 0,
    };
    this.updateActive();
  }

  updateActive() {
    const { bgImages, activeImgIndex } = this.state;
    setTimeout(() => {
      const active = (activeImgIndex + 1) % bgImages.length;
      this.setState({ activeImgIndex: active }, () => {
        this.updateActive();
      });
    }, 10000);
  }

  render() {
    const { bgImages, activeImgIndex } = this.state;
    return (
      <section id="hero-bg-slideshow" className="hero hero-slideshow" style={{ height: window.innerWidth > 800 ? '980px' : '680px' }}>

        <div className="hero-slides-wrapper flexslider h-100 w-100">
          <div className="slides h-100 w-100">
            {bgImages.map((imgClass, index) => {
              const active = activeImgIndex === index;
              const activeClass = active ? 'flex-active-slide' : '';
              const style = active ? activeSlideStyle : defaultSlideStyle;
              return (<span key={index} className={`bg-img-cover bg-overlay-black-5 d-block h-100 w-100 ${activeClass}`} style={style} />);
            })}
          </div>
        </div>
        <div className="hero-slideshow-content">
          <div className="container h-100">
            <div className="row align-items-center h-100 justify-content-center no-gutters">
              <div className="col-lg-12 text-center">
                <div className="">
                  <h2 className="font-alt2 text-white title-extra-large-2 title-md-extra-large-5 title-xl-big">
                    {'Arturo '}
                    <span className="text-base-color"> &amp; </span>
                    {' Melissa'}
                  </h2>
                  <h3 className="font-alt letter-spacing-1 mt-2 text-medium text-xl-large text-uppercase text-white">
					We Are Getting Married
                    <br />
					June 27, 2019
                  </h3>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}
export default HeaderSection;
